import React from "react"

const RemoveCircleIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <circle fill="currentColor" cx="10" cy="10" r="10" />
      <path
        d="M13.536 6.464l-7.072 7.072M6.464 6.464l7.072 7.072"
        stroke="#FFF"
        strokeWidth="2"
        strokeLinecap="round" />
    </g>
  </svg>
)

export default RemoveCircleIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/RemoveCircleIcon.jsx